import { customerPartnerFunctionsSlice } from "./customerPartnerFunctionsSlice";
import * as actions from "./customerPartnerFunctionsActions";
import * as selectors from "./customerPartnerFunctionsSelectors";

export { actions };
export { selectors };
export default customerPartnerFunctionsSlice.reducer;
